import type { CancelTokenSource } from 'axios'
import axios from 'axios'

export const useCancelTokenStore = defineStore('calcelToken', () => {
  const cancelTokenSource = ref<CancelTokenSource | null>(null)

  const setToken = () => {
    if (cancelTokenSource.value) {
      cancelTokenSource.value.cancel('Cancelling previous request')
    }
    cancelTokenSource.value = axios.CancelToken.source()
  }

  const unsetToken = () => {
    cancelTokenSource.value = null
  }

  return { cancelTokenSource, setToken, unsetToken }
})
